import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // console.log('Newsletter module initialized');
        var btnTrigger = document.getElementById('btnInfolettre');

        function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) {
                    // console.log("Cookie " + name + " is active.");
                    return c.substring(nameEQ.length, c.length);
                }
            }
            // console.log("Cookie " + name + " is not active.");
            return null;
        }


        if (btnTrigger) {
            // console.log('Button found:');
            // Simuler le clic sur le bouton
            setTimeout(function() {
                // Simuler le clic sur le bouton
                if (!getCookie('modalpopup')) {
                    btnTrigger.click();
                }
                
            }, 300); // Délai de 1000 millisecondes (1 seconde)
        } else {
            // console.error('Button with ID btnInfolettre not found');
        }
    }
}